/* eslint-disable camelcase */
/* eslint-disable camelcase */
import actions from './actions'

const initialState = {
  data: {},
  transactions: [],
  loading: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
